import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Counter } from "../../types";
import { DislikeIcon } from "../../icons/comment/dislike";
import { LikeIcon } from "../../icons/comment/like";
import { commentBackend } from "../../services";
import { actions } from "../../state/reducer";
import { generateRandomString } from "../../utils";

const CommentLikeRow = (props: { comment_id: number; counters: Counter[] }) => {
  const dispatch = useDispatch();
  const { comment_id, counters } = props;

  const putLike = (value: number) => {
    commentBackend
      .likeComment({
        comment_id,
        value_id: value,
      })
      .then(() => {
        dispatch(actions.selectItem(generateRandomString(4)));
      });
  };

  return (
    <div className="flex gap12">
      {counters.map((item, index) => {
        return (
          <div
            key={index}
            className={`likeCounter flex ${
              item.value === 1 ? "like" : "dislike"
            } vertCenter aBtn`}
            onClick={putLike.bind(this, item.value)}
          >
            {item.value === 1 ? (
              <LikeIcon width={18} height={18} />
            ) : (
              <DislikeIcon width={18} height={18} />
            )}
            <span>{item.count}</span>
          </div>
        );
      })}
    </div>
  );
};

export default CommentLikeRow;
